import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'

export default class SliderDouble {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    const speed = 800

    const swiperSecondary = new Swiper(this.el.querySelector('.slider-double--slider-secondary'), {
      slidesPerView: 1,
      initialSlide: 1,
      loop: true,
      allowTouchMove: false,
      speed,
    })

    const swiperPrimary = new Swiper(this.el.querySelector('.slider-double--slider-main'), {
      modules: [Navigation, Autoplay],
      autoplay: true,
      slidesPerView: 1,
      speed,
      loop: true,
      longSwipesRatio: 0.01,
      watchSlidesProgress: true,
      navigation: {
        nextEl: this.el.querySelector('.swiper-button-next'),
        prevEl: this.el.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        0: {
          grabCursor: true,
          navigation: { enabled: false },
        },
        992: {
          grabCursor: false,
          navigation: { enabled: true },
        },
      },
    })

    swiperPrimary.on('slideNextTransitionStart', () => swiperSecondary.slideNext())
    swiperPrimary.on('slidePrevTransitionStart', () => swiperSecondary.slidePrev())
  }
}
